
















































































import { TicketParams } from '@/store/interfaces/tickets';
import transaction from '@/store/types/transaction';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import PaymentMethods from '@/components/Reusable/paymentMethods.vue';
import StatusBadges from '@/components/Reusable/statusBadges.vue';
import ResumenCard from '@/components/AccountsList/ResumenCard.vue';
import TransferModal from '@/components/AccountsList/TransferModal.vue';
import DetailModal from '@/components/AccountsList/DetailModal.vue';
import LineChart from '@/components/Argon/Charts/LineChart';
import Card from '@/components/Argon/Cards/Card.vue';
type chartData = {
  datasets: { data: number[]; backgroundColor: string[] }[];
  labels: string[];
};

export default Vue.extend({
  name: 'Tickets',
  components: {
    TransferModal,
    Card,
    LineChart,
    DetailModal,
    ResumenCard,
    PaymentMethods,
    StatusBadges,
  },
  data: () => ({
    rowselect: {},
    newTransferModal: false,
    showDetailModal: false,
    propsToSearch: [] as tPropsToSearch,
    chartData: {
      datasets: [
        {
          data: [120, 200],
          backgroundColor: [
            '#00000000'
          ],
        }
      ],
      labels: ['Billetera dígital', 'Billetera Operativa'],
    } as chartData,
    extraOotions: {
      legend: {
        display: false,
      },
      responsive: true,
      maintainAspectRatio: false,
    },
    tableColumns: [
      {
        prop: 'commerce_name',
        label: 'Institución',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'total_formatted',
        label: 'Monto',
        minWidth: 100,
        sortable: true,
      },
      {
        prop: 'status',
        label: 'Estado',
        minWidth: 150,
        sortable: true,
        slotName: 'status',
      },
      {
        prop: 'type',
        label: 'Tipo',
        minWidth: 150,
        sortable: true,
        slotName: 'type',
      }
    ] as tTableColumns,
  }),
  computed: {
    ...mapGetters({
      getTransactionList: `transactionModule/${transaction.getters.GET_POSTMORTEM_TRANSACTIONS}`,
    }),
  },
  methods: {
    ...mapActions({
      transactionList: `transactionModule/${transaction.actions.POSTMORTEM_TRANSACTION_LIST}`,
    }),
    ticketSelected(ticket: TicketParams) {
      this.rowselect = ticket;
    },
  },
});
